import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useFelaEnhanced } from '@ackee/fela';
import { DynamicContainer, Title, TitleTypes } from 'modules/ui';
import type { BlogPost } from '../../types';
import { BlogPostsList } from '../BlogPostsList';

import * as felaRules from './OtherPosts.rules';

export interface OtherPostsProps {
    posts: BlogPost[];
}

export const OtherPosts = ({ posts }: OtherPostsProps) => {
    const { rules } = useFelaEnhanced(felaRules);

    return (
        <DynamicContainer isFluid extend={{ container: rules.postsContainer }}>
            {/** @ts-expect-error */}
            <Title type={TitleTypes.H3}>
                <FormattedMessage id="blog.detail.otherPosts" />
            </Title>
            <BlogPostsList posts={posts} extend={{ posts: rules.posts, post: rules.post }} />
        </DynamicContainer>
    );
};
